export const categoryLabel = (cat) => {
  const labels = {
    // emisiones GEI
    'generacion electrica': 'Generación Eléctrica',
    'industria y mineria': 'Industria y Minería',
    publico: 'Público',
    'otras industrias energia': 'Otras Industrias Energía',
    'otros sectores': 'Otros Sectores',
    'emisiones fugitivas': 'Emisiones Fugitivas',
    'procesos industriales': 'Procesos Industriales',
    forestal: 'Forestal',

    // demanda energia
    azucar: 'Azúcar',
    industrias_varias: 'Industrias varias',
    minas_varias: 'Minas varias',
    petroquimica: 'Petroquímica',
    siderurgia: 'Siderúrgica',
    transporte_aereo: 'Transporte aéreo',
    transporte_caminero_carga: 'Trans. caminero \ncarga',
    transporte_caminero_pasajeros: 'Trans. caminero \npasajeros',
    transporte_ferroviario_carga: 'Trans. ferroviario \ncarga',
    transporte_ferroviario_pasajeros: 'Trans. ferroviario \npasajeros',
    transporte_maritimo: 'Transporte marítimo',

    // demanda energia por combustible
    'gas natural': 'Gas natural',
    gas_natural: 'Gas natural',
    diesel: 'Diésel',
    diesel_hibrido: 'Diésel híbrido',
    diesel_renovable: 'Diésel renovable',
    electricidad: 'Electricidad',
    electricidad_reconv: 'Electricidad reconversión',
    gasolina: 'Gasolina',
    gasolina_aviacion: 'Gasolina aviación',
    gasolina_hibrido: 'Gasolina híbrida',
    'gas licuado': 'Gas licuado',
    gas_licuado: 'Gas licuado',
    'fuel oil': 'Fuel oil',
    fuel_oil: 'Fuel oil',
    kerosene: 'Kerosene',
    kerosene_aviacion: 'Kerosene aviación',
    biomasa: 'Biomasa',
    lena: 'Leña',
    hidrogeno: 'Hidrógeno',
    alquitran: 'Alquitrán',
    coque_mineral: 'Coque mineral',
    coque_petroleo: 'Coque petróleo',
    gas_alto_horno: 'Gas alto horno',
    gas_coque: 'Gas coque',
    hidro: 'Hidro',
    kerojet_HEFA: 'Kerojet HEFA',
    kerojet_sintetico: 'Kerojet sintético',
    petroleo_combustible: 'Petróleo combustible',
    solar: 'Solar',

    // generacion
    carbon: 'Carbón',
    eolica: 'Eólica',
    geotermia: 'Geotérmica',
    almacenamiento: 'Almacenamiento',
    'hidraulica embalse': 'Hidráulica embalse',
    'hidraulica pasada': 'Hidráulica pasada',
    'hidraulica serie': 'Hidráulica serie',
    'solar csp': 'Solar CSP',
    'solar fv': 'Solar FV',

    // escenarios
    'Escenario Base': 'Escenario Base',
    'Carbono Neutralidad 1 (CN1)': 'Carbono Neutralidad 1 (CN1)',
    'Carbono Neutralidad 2 (CN2)': 'Carbono Neutralidad 2 (CN2)',
    
  };

  return labels[cat]
    ? labels[cat] : cat.charAt(0).toUpperCase() + cat.slice(1);; 
};

export const parseValue = value => ( value ? parseFloat(value.replace(/,/g, '')) : null);

export const truncOneDecimal = (value) => {
  const parts = String(value).split(',');
  if (parts.length > 1) {
    return parts[0] + ',' + parts[1][0];
  }
  return value;
}
export const truncTwoDecimals = (value) => {
  const parts = String(value).split(',');
  if (parts.length > 1) {
    return parts[0] + ',' + parts[1][0-1];
  }
  return value;
}
export const numberToTwoDecimals = (value) => {
  return Number(value).toFixed(2)
}
export const toOneDecimal = (dic) => {
  const new_dict = {};
  for(var x in dic){
      new_dict[x] = Number(dic[x]).toFixed(1)
  }
  return new_dict
}
export const toTwoDecimals = (dic) => {
  const new_dict = {};
  for(var x in dic){
      new_dict[x] = Number(dic[x]).toFixed(2)
  }
  return new_dict
}
